import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 shadow-sm">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-center">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://upload.wikimedia.org/wikipedia/commons/b/ba/Swissborg-logo.png" 
              alt="SwissBorg" 
              className="h-10 w-auto md:h-12"
            />
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;
